module.exports = __webpack_public_path__ + "static/media/company-home-11.15587cad.png";